import React from 'react';
import TypeWriterEffect from 'react-typewriter-effect';
import background from '../images/bg1.jpg';

const TypeWriter = ({ businessName, businessDescription }) => {
  const divStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };
  return (
    <div>
      <div className='py-4  mt-10 rounded-t-full flex flex-col bg-[#0a8095] shadow-2xl' style={divStyle}>
        <div className='flex justify-center  '>
          <TypeWriterEffect
            textStyle={{
              color: 'black',
              fontWeight: 'bold', // Change the font weight to 'bold'
              fontSize: '1.5rem', // Change the font size to '2rem'
            }}
            startDelay={0}
            cursorColor="transparent"
            multiText={[businessName, businessDescription]} // Use the variables directly
            multiTextDelay={4000}
            typeSpeed={60}
            multiTextLoop={true}
            hideCursorAfterText={false}
          />
        </div>
        <div className="h-[1px] w-[240px] mx-auto mt-4 bg-line"></div>
      </div>
    </div>
  );
};

export default TypeWriter;
